import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './icon-box11.module.scss';
import { IconBox11Type } from '@/types/contactsBlock.types';

const IconBox11: NextPage<IconBox11Type> = ({
  className = '',
  title,
  info,
  iconSrc,
}) => {
  return (
    <div className={[styles.iconBox1, className].join(' ')}>
      <Image
        className={styles.icon}
        loading="lazy"
        width={64}
        height={64}
        sizes="100vw"
        alt=""
        src={iconSrc}
      />
      <div className={styles.title}>
        <div className={styles.title1}>{title}</div>
        <h3 className={styles.info}>{info}</h3>
      </div>
    </div>
  );
};

export default IconBox11;
